"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersPage = void 0;
const grid_1 = require("@components/grid");
const popup_1 = require("@components/popup");
const user_edit_form_1 = require("@components/user-edit-form");
const user_filter_1 = require("@components/user-filter");
const user_hooks_1 = require("@hooks/user.hooks");
const React = __importStar(require("react"));
const react_1 = require("react");
const helper_1 = require("./helper");
const UsersPage = (props) => {
    const [filters, setFilters] = (0, react_1.useState)({ wallet: "" });
    const [selectedUser, setSelectedUser] = (0, react_1.useState)({ wallet: "" });
    const [isOpenUserPopUp, setOpenUserPopUp] = (0, react_1.useState)(false);
    const { list, setPage, loaderState: { total = 0, size }, forceReload, } = (0, user_hooks_1.useUserList)(Object.assign({}, filters), { preSave: false });
    const editUserHandler = (0, react_1.useCallback)((wallet, referralRate) => {
        setSelectedUser({ wallet, referralRate });
        setOpenUserPopUp(true);
    }, []);
    const closeUserEditing = (0, react_1.useCallback)(() => {
        setOpenUserPopUp(false);
        forceReload();
    }, []);
    const config = (0, react_1.useMemo)(() => (0, helper_1.getColumnConfig)(editUserHandler), [editUserHandler]);
    return (React.createElement("div", { className: "p-tokens-page" },
        React.createElement(user_filter_1.UserFilter, { filters: filters, setFilters: setFilters }),
        React.createElement(grid_1.Grid, { data: list, onPageChange: setPage, getKey: ({ wallet }) => wallet, columns: config, pageSize: size, totalSize: Math.ceil(total / size) }),
        React.createElement(popup_1.Popup, { isOpened: isOpenUserPopUp, onClose: closeUserEditing }, isOpenUserPopUp && React.createElement(user_edit_form_1.EditUserForm, { user: selectedUser, onClose: closeUserEditing }))));
};
exports.UsersPage = UsersPage;
